import PageContainer from '../../page-container';
import LocalizedStrings from '../../../localization/strings';

import React from 'react';
import Loading from '../../../components/loading';

class ConfigurationContainer extends PageContainer {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      loading: true
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    fetch('/api/config-info')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => this.setState({ data, loading: false }))
      .catch((error) => this.setState({ error, loading: false }));
  }

  render() {
    const { data, loading } = this.state;

    return (
      <div className="panel">
        <header className="panel-header">{LocalizedStrings.configuration}</header>
        <div className="panel-body">
          {loading
            ? <Loading />
            : <div>
              <fieldset>
                <legend>Paysera</legend>
                <div><b>ID:</b> {data.paysera.projectId} </div>
                <div><b>Bandomieji mokėjimai:</b> {data.paysera.testPayment ? 'Taip' : 'Ne'} </div>
                <div><b>Mokėjimas iškart:</b> {data.paysera.instantPayment ? 'Taip' : 'Ne'} </div>
                <div><b>Matomi tik apmokėję dalyviai:</b> {data.paysera.onlyPayedParticipants ? 'Taip' : 'Ne'} </div>
              </fieldset>
              <fieldset>
                <legend>El. paštas</legend>
                <div><b>Siuntimo adresas:</b> {data.email.emailFrom} </div>
                <div><b>SMTP serveris:</b> {data.email.server} </div>
                <div><b>SMTP vartotojas:</b> {data.email.smtpUser} </div>
              </fieldset>
              <fieldset>
                <legend>Sąskaitos</legend>
                <div><b>Sąskaitų generavimas įjungtas:</b> {data.invoices.generate ? 'Taip' : 'Ne'} </div>
                <div><b>Sąskaitų serija:</b> {data.invoices.serialPlaceholder} </div>
                <div><b>Sąskaitų išrašymas:</b> {data.invoices.sellerInfo} </div>
              </fieldset>
              <fieldset>
                <legend>Dalyviai</legend>
                <div><b>Dalyvio BARCODE generavimas:</b> {data.participant.barcode ? 'Taip' : 'Ne'} </div>
                <div><b>Minimalus narių skaičius komandos registracijoje:</b> {data.participant.minTeamMembers} </div>
                <div><b>Registracijos papildomo lauko konfigūracija:</b> {data.participant.participantCustomField} </div>
                <div><b>Šalies pasirinkimas:</b> {data.participant.countrySelection} </div>

              </fieldset>
              <fieldset>
                <legend>Kainos</legend>
                <div> amžius {'<='} {data.pricing.ageGroups.children} </div>
                <div> {data.pricing.ageGroups.children} {'<'} amžius {'<'} {data.pricing.ageGroups.older} </div>
                <div> amžius {'>='} {data.pricing.ageGroups.older} </div>


              </fieldset>
              <fieldset>
                <legend>Pagrindinio puslapio paveikslėliai</legend>
                {window.CARE_CONFIG.landingImages.map((image, index) => {
                  return <div key={index}><img src={image} width={200} /></div>
                })}
              </fieldset>


            </div>
          }
        </div>
      </div>
    );

  }
}


export default ConfigurationContainer;



// WEBPACK FOOTER //
// ./src/js/containers/admin/settings/configuration-container.js